'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

listeners();

/**
*
* ------------------------------------------------------------------------------
*
*
* @namespace home
*/

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)('.hp-testimonials-slider').slick({
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 250,
    fade: true,
    cssEase: 'linear',
    prevArrow: (0, _jquery2.default)('.hp-slider-arrow-left'),
    nextArrow: (0, _jquery2.default)('.hp-slider-arrow-right'),
    responsive: [{
      breakpoint: 769,
      settings: {
        autoplay: false,
        adaptiveHeight: true
      }
    }]
  });
});

function listeners() {}